/**
 * «Свободен ли по графику всё время» — квадратик у «+» игр, допработ и учёбок.
 * 13.10: вынесено из OoAssignScreen.tsx без изменений (карточка допработы переехала в
 * oo/ExtraWorkCard.tsx, а проверку зовут и она, и карточка игры).
 */
import type { BoardOperator } from "../../hooks/useOoDay";

/** 27.09 (владелец): тот же квадратик у «+» допработ и учёбок — каждый час их интервала
 *  [с, до) свободен по графику; «до» раньше «с» — работа уходит за полночь. */
export function canWholeWork(op: BoardOperator, from: string, to: string): boolean {
  const mm = (t: string) => { const [h, m] = t.split(":").map(Number); return (h ?? 0) * 60 + (m ?? 0); };
  const d = mm(to) - mm(from);
  return canWholeSpan(op, from, d > 0 ? d : d + 1440);
}

export function canWholeSpan(op: BoardOperator, from: string, minutes: number): boolean {
  const [h, m] = from.split(":").map(Number);
  const start = (h ?? 0) * 60 + (m ?? 0);
  const end = start + (minutes || 60);
  for (let t = Math.floor(start / 60); t * 60 < end; t++) {
    const hh = ((t % 24) + 24) % 24;
    if (!op.avail.includes(`${String(hh).padStart(2, "0")}:00`)) return false;
  }
  return true;
}
